import { render } from "./ViewPracticePhonemicVowel.vue?vue&type=template&id=e428dc88&scoped=true"
import script from "./ViewPracticePhonemicVowel.vue?vue&type=script&lang=js"
export * from "./ViewPracticePhonemicVowel.vue?vue&type=script&lang=js"

import "@/css/views/view-practice-phonemic-vowel.css?vue&type=style&index=0&id=e428dc88&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e428dc88"]])

export default __exports__